<section class="bg-(--color-secondary) py-16 overflow-hidden">
  <div class="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 space-y-16">
    <!-- Section 1 -->
    <div class="grid grid-cols-1 lg:grid-cols-[390px_1fr] gap-20 items-start" dir="ltr">
      <!-- Left Image -->
      <div>
        <img
          src="/images/service-details.png"
          alt="service-details"
          class="w-full h-107.5 rounded-xl object-cover object-center"
        />
      </div>

      <!-- Right Content -->
      <div class="text-right pt-0" dir="rtl">
        <div class="flex">
          <span
            class="inline-flex items-center gap-2 px-10 py-2 rounded-lg bg-(--color-main-20) text-(--color-main) shadow-[0_4px_4px_rgba(0,0,0,0.25)] font-medium"
          >
            <svg class="w-4 h-4" viewBox="0 0 20 20" fill="none">
              <path
                d="M6 4l6 6-6 6"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            الخدمات
          </span>
        </div>

        <h3 class="details-text mt-7 text-center lg:text-right">الخدمات الأساسية</h3>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-x-14 gap-y-10 mt-8" >
          <div>
            <div class="flex items-center justify-start gap-2">
              <img src="/icons/service-icon.svg" class="w-9 h-9" />

              <h4 class="text-(--color-main) font-bold text-lg leading-snug">
                تخطيط وإدارة المشاريع الزراعية
              </h4>
            </div>
            <p class="text-(--color-main) mt-4 text-sm leading-[1.9]">
              نتولى عنك كافة الجوانب التشغيلية للمشروع، من اختيار الأرض المناسبة، إلى تجهيزها
              وزراعتها، ومتابعة المحصول، وحتى الحصاد والبيع. فريقنا من المهندسين الزراعيين يطبّق
              أحدث الممارسات لضمان أعلى إنتاجية.
            </p>
          </div>

          <div>
            <div class="flex items-center justify-start gap-2">
              <img src="/icons/service-icon.svg" class="w-9 h-9" />

              <h4 class="text-(--color-main) font-bold text-lg leading-snug">
                الاستشارات الزراعية والمالية
              </h4>
            </div>
            <p class="text-(--color-main) mt-4 text-sm leading-[1.9]">
              نوفر لك مستشارين متخصصين تستطيع التواصل معهم لتحليل الفرص، فهم الميزانيات، مراجعة
              العقود، أو الحصول على نصائح حول تنويع محفظتك التعاقدية.
            </p>
          </div>

          <div class="md:col-start-1">
            <div class="flex items-center justify-start gap-2">
              <img src="/icons/service-icon.svg" class="w-9 h-9" />

              <h4 class="text-(--color-main) font-bold text-lg leading-snug">
                تطبيق الزراعة المستدامة
              </h4>
            </div>
            <p class="text-(--color-main) mt-4 text-sm leading-[1.9]">
              نطبّق أحدث تقنيات الزراعة المستدامة: الري بالتنقيط، الزراعة العضوية، الإدارة الذكية
              للتربة، واستخدام الطاقة المتجددة. هذا يضمن عوائد مستقرة على المدى الطويل، ويحافظ على
              الأرض والموارد.
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Section 2 -->
    <div class="grid grid-cols-1 lg:grid-cols-[1fr_450px] gap-16 items-start" dir="ltr">
      <!-- Left Content -->
      <div class="pt-2">
        <h3 class="details-text mb-10 text-right">الخدمات الرقمية المتقدمة</h3>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-12">
          <div>
            <div class="flex items-center justify-end gap-2">
              <h4 class="text-(--color-main) font-bold text-lg">المساعد الذكي بالـ AI</h4>
              <img src="/icons/service-icon.svg" class="w-9 h-9" />
            </div>
            <p class="text-(--color-main) mt-4 text-sm leading-[1.9] text-right">
              داخل تطبيق أولاً، ستجد مساعداً ذكياً يعمل بالذكاء الاصطناعي. يمكنك التحدث معه وكأنك
              تتحدث مع مستشار شخصي، يجاوبك على أسئلتك، يحلّل المبلغ المتاح لديك، ويرشّح لك أفضل
              الفرص المناسبة.
            </p>
          </div>

          <div>
            <div class="flex items-center justify-end gap-2">
              <h4 class="text-(--color-main) font-bold text-lg">المحفظة الرقمية المتكاملة</h4>
              <img src="/icons/service-icon.svg" class="w-9 h-9" />
            </div>
            <p class="text-(--color-main) mt-4 text-sm leading-[1.9] text-right">
              محفظة إلكترونية آمنة لإدارة كافة معاملاتك التعاقدية: شحن الرصيد، الدخول في فرص جديدة،
              استلام العوائد، والسحب المباشر. كل ذلك بضغطة زر، مع سجل كامل لكل عملية.
            </p>
          </div>

          <div>
            <div class="flex items-center justify-end gap-2">
              <h4 class="text-(--color-main) font-bold text-lg">المتابعة اللحظية للمشاريع</h4>
              <img src="/icons/service-icon.svg" class="w-9 h-9" />
            </div>
            <p class="text-(--color-main) mt-4 pb-2 text-sm leading-[1.9] text-right">
              تابع مشاريعك التعاقدية لحظة بلحظة من خلال التطبيق:
            </p>
            <ul class="text-(--color-main) text-sm leading-[1.9] list-none text-right">
              <li>- صور وفيديوهات حقيقية تُرفع باستمرار من موقع المشروع.</li>
              <li>- تقارير دورية عن تطور المشروع ومراحله.</li>
              <li>- إشعارات فورية بأي تحديث مهم.</li>
              <li>- عداد للأيام المتبقية على نزول العوائد.</li>
              <li>- توثيق كامل لمراحل البيع والتسليم.</li>
            </ul>
          </div>

          <div>
            <div class="flex items-center justify-end gap-2">
              <h4 class="text-(--color-main) font-bold text-lg">الدعم القانوني والفني</h4>
              <img src="/icons/service-icon.svg" class="w-9 h-9" />
            </div>
            <p class="text-(--color-main) mt-4 pb-2 text-sm leading-[1.9] text-right">نوفر لك:</p>
            <ul class="text-(--color-main) text-sm leading-[1.9] list-none text-right">
              <li>- استشارات قانونية لفهم بنود العقود وحقوقك التعاقدية.</li>
              <li>- فيديوهات تعليمية لشرح كل فرصة من الجانب الفني والمالي.</li>
              <li>- دعم فني مباشر متاح 24/7 لحل أي مشكلة في التطبيق.</li>
              <li>- مراجعة العقود قبل التوقيع مع فريقنا القانوني.</li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Right Image -->
      <div>
        <img
          src="/images/service-details.png"
          alt="service-details"
          class="w-full h-107.5 rounded-xl object-cover object-center"
        />
      </div>
    </div>
  </div>
</section>
